const modal = {
  filter: {
    title: 'Apotheken filtern',
    filterBy: 'Filtern nach',
    selectedFilters: 'Gewählte Filter',
    clearFilters: 'Filter löschen',
    onlinePayment: 'Online-Zahlung',
    servicesIcon: 'Dienste-Symbol',
    magazineIcon: 'Magazin-Symbol',
  },
  login: {
    welcome: {
      0: 'Willkommen',
      1: 'bitte',
      2: 'melden',
      3: 'Sie sich hier',
      4: 'an.',
    },
    new: 'Neu bei IhreApotheken.de?',
    join: 'Jetzt registrieren',
    remember: 'An mich erinnern',
  },
  logout: {
    title: 'Möchten Sie sich wirklich abmelden?',
    description: 'Wenn Sie sich abmelden, wird Ihr Warenkorb geleert und Sie werden zur Startseite weitergeleitet',
    confirm: 'Abmelden',
    cancel: 'Nein, angemeldet bleiben',
  },
  loggedOut: {
    close: 'Schließen',
    message: 'Sie haben sich erfolgreich abgemeldet.',
  },
  maxAmount: {
    title: 'Die maximale Bestellmenge für das Produkt wurde aus arzneimittelrechtlichen Gründen erreicht.',
    close: 'Schließen',
  },
  coupon: {
    title: 'Coupon Deaktivierung',
    description: 'Sind Sie sicher, dass Sie den Coupon entfernen möchten?',
    confirm: 'Ja',
    cancel: 'Nein',
  },
  pharmacyInfo: {
    messengerServicePossible: 'Botendienst mit Termin',
    onlinePayment: 'Online-Zahlung möglich',
    changePharmacy: 'Apotheke wechseln',
    yourPharmacy: 'ihre ausgewählte apotheke',
    toWebsite: 'Zur Webseite',
    deliveryCost: 'Botendienstkosten: ',
    expressDeliveryCostFrom: 'Express-Lieferung ab: ',
    freeExpressDeliveryCostFrom: 'Kostenfreie Express-Lieferung ab: ',
    deliveryCostFrom: 'Lieferung ab: ',
    freeDeliveryCostFrom: 'Kostenfreie Lieferung ab: ',
    zipCodes: 'Lieferung an PLZ: {codes}',
    distanceLimit: 'Lieferung im Radius von: {distance}',
    pharmacyInfo: 'Apothekeninformationen',
    serviceIcon: 'Service-Symbol',
    whatsAppDescription: 'Kontaktieren Sie uns direkt über WhatsApp indem Sie den QR-Code scannen oder auf dem WhatsApp-Button klicken, um den Chat im Browser zu öffnen.',
  },
  cancelOrder: {
    title: 'Stornierung Ihrer Bestellung',
    description: 'Bitte kontaktieren Sie Ihre Apotheke unter der Telefonnummer {pharmacyPhoneNumber}, um Ihre Bestellung zu stornieren.',
    descriptionNoPhone: 'Bitte kontaktieren Sie Ihre Apotheke unter den oben aufgeführten Kontaktdaten, um Ihre Bestellung zu stornieren.',
  },
  emptyCart: {
    title: 'Sie haben momentan keine Produkte in Ihrem Warenkorb.',
    description: 'Stöbern Sie in unseren Kategorien oder suchen Sie einfach über das Suchfeld ein Produkt Ihrer Wahl.',
    confirmText: 'Produkte entdecken',
  },
  epaper: {
    title: 'my life E-Paper Abonnement kündigen',
    description: 'Möchten Sie Ihr my life E-Paper-Abonnement wirklich kündigen? Das Magazin steht dann digital nicht mehr für Sie zur Verfügung. Sie erhalten die my life natürlich weiterhin wie gewohnt als Zeitschrift in Ihrer Apotheke vor Ort.',
    confirmText: 'Abonnement kündigen',
    cancelText: 'Abbrechen',
  },
  iaAppDownload: {
    title: 'Jetzt App herunterladen!',
    description: 'Bestellen Sie noch bequemer und nutzen Sie exklusive App-Funktionen wie die Einnahme-Erinnerung für Ihre Medikamente.',
  },
  locationPermission: {
    title: 'Ortungsdienst deaktiviert',
    description: 'Sie haben den Ortungsdienst in Ihrem Browser deaktiviert. Sie können diesen jederzeit in Ihren Browsereinstellungen wieder aktivieren.',
    confirmText: 'Schließen',
  },
  disabledCameraAccess: {
    title: 'Kameraberechtigung verweigert',
    description: 'Ups, es sieht so aus, als könnten wir nicht auf Ihre Kamera zugreifen. Bitte aktivieren Sie sie in Ihren Browsereinstellungen oder überprüfen Sie, ob sie richtig angeschlossen ist.',
    confirmText: 'Schließen',
  },
  emptySearch: {
    noTermDescription: 'Bitte geben Sie einen Suchbegriff, einen Produktnamen, eine PZN oder eine Kategorie in das Suchfeld ein.',
    description: 'Um Ihre Suche zu starten, geben Sie bitte die ersten 3 Zeichen des Medikaments oder der PZN-Nummer ein.',
  },
  advertisement: {
    title: 'Suchergebnis',
    description: 'Sind Produkte als „Anzeige“ gekennzeichnet, handelt es sich um bezahlte Werbung. Sie werden an erster Stelle angeführt. Die Reihenfolge der angezeigten Produkte richtet sich im Übrigen nach der ausgewählten Option der Sortierung. Unter „Beliebtheit“ werden die Suchtreffer unter Berücksichtigung der eingegebenen Suchbegriffe je nach Relevanz angezeigt. Hier werden auch die Verkaufsdaten der letzten Monate zur Erstellung der angezeigten Reihenfolge berücksichtigt. Unter „Produktname“ werden alle Suchtreffer zu dem eingegebenen Suchbegriff in der alphabetischen Reihenfolge angezeigt.',
  },
}

export default modal
